/*
 * Copyright (c) ${year}. Sayari LLC
 */

export class LoginUser {
    username: string;
    password: string;
    grantType: string;
}